import { render, staticRenderFns } from "./Spreadsheet.vue?vue&type=template&id=509bf6f8"
import script from "./Spreadsheet.vue?vue&type=script&lang=js"
export * from "./Spreadsheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports